import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux'
import { CircularProgress } from 'material-ui/Progress'
import { connect } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, DialogContentText } from "material-ui";
import { Field, reduxForm } from 'redux-form';
import FormPasswordToggleField from './formPasswordToggleField';
import FormSelector from './formSelector';
import FormTextField from './formTextField';
import { formValueSelector } from 'redux-form'
import green from 'material-ui/colors/green'
import Messages from "../constants/messages"
import { preserveReduxFormValueOnToggle } from '../modules/securityQuestionsFormDialog'
import PropTypes from 'prop-types'
import { required, minCharacters, notContainEmail, notContainPassword, notBeQuestionPart } from '../utils/validationRules';
import { SecurityQuestionRequirements } from '../components/securityQuestionRequirements'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  answer: PropTypes.string,
  classes: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  hideCancelBtn: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  password: PropTypes.string,
  preserveReduxFormValueOnToggle: PropTypes.func.isRequired,
  question: PropTypes.string,
  resetForm: PropTypes.func.isRequired,
  securityQuestionsList: PropTypes.array.isRequired,
  setSecurityQuestion: PropTypes.func.isRequired,
  showSecurityQuestionsDialog: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
}

const styles = theme => ({
  root: {
    float: 'right',
    marginBottom: 15
  },
  btn: {
    textAlign: 'right'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    right: '-0.5em',
    bottom: '0.3em',
    overflow: 'hidden'
  },
  confirmCheck: {
    color: green[500],
    '&:after': {
      content: "' \u2714'"
    }
  },
  confirmNoCheck: {
    color: green[500]
  },
  dialogActions: {
    position: 'relative'
  },
  portalContainer: {
    overflow: "scroll"
  },
  field: {
    marginBottom: 15
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
  },
  notSelected: {
    backgroundColor: "none", //Overides for deselecting in multiselect menuItems
    '&:focus': {
      background: "none",
    }
  },
  svg: {
    height: '24px',
    width: '24px'
  }
})

// SecurityQuestionsFormDialog component serves a temporary workaround for known issues in the general-purpose FormDialog component
// Refactor of FormDialog component planned.

class SecurityQuestionsFormDialog extends Component {

  renderDialog() {
    const {
      answer,
      classes,
      email,
      handleSubmit,
      hideCancelBtn,
      invalid,
      isSubmitting,
      open,
      password,
      preserveReduxFormValueOnToggle,
      pristine,
      question,
      resetForm,
      securityQuestionsList,
      setSecurityQuestion,
      showSecurityQuestionsDialog,
      title,
      userId
    } = this.props
    return (
      <Dialog
        id="securityQuestionsFormDialog"
        open={open}
        onRequestClose={() => {
          showSecurityQuestionsDialog(false)
          resetForm()
        }}
        fullWidth={true}>
        <div className={`${classes.portalContainer} portalContainer`}>
          <DialogTitle>{title}</DialogTitle>
          <form data-test-id="setSecurityQuestionDialog" onSubmit={handleSubmit((formValues) => {
            setSecurityQuestion(userId, formValues).then((action) => { if (!action.error) resetForm() })
          })}>
            <DialogContent>
              <DialogContentText>
                <SecurityQuestionRequirements
                  answer={answer}
                  classes={classes}
                  email={email}
                  password={password}
                  question={question} />
              </DialogContentText>
              <Field
                name="password"
                component={FormTextField}
                label={Messages['uiComponents']['CURRENT_PASSWORD_LABEL']}
                disabled={isSubmitting}
                type="password"
                validate={[required]} />
              <Field
                name="question"
                component={FormSelector}
                label={Messages['uiComponents']['SECURITY_QUESTION_LABEL']}
                disabled={isSubmitting}
                optionsList={securityQuestionsList}
                type="text"
                validate={[required]} />
              <Field
                name="answer"
                component={FormPasswordToggleField}
                label={Messages['uiComponents']['ANSWER_LABEL']}
                disabled={isSubmitting}
                preserveReduxFormValueOnToggle={preserveReduxFormValueOnToggle}
                type="password"
                validate={[required, minCharacters, notContainEmail, notContainPassword, notBeQuestionPart]} />
              {/* Hidden email field required for validation (see Redux-form docs) */}
              <Field
                name="email"
                component="input"
                type="hidden" />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {hideCancelBtn ? null :
                <Button
                  data-test-id="cancelBtn"
                  color="primary"
                  disabled={isSubmitting}
                  onClick={() => {
                    showSecurityQuestionsDialog(false)
                    resetForm()
                  }}>
                  {Messages['uiComponents']['FORM_DIALOG_CANCEL_BUTTON_LABEL']}
                </Button>
              }
              <Button id="submitBtn" color="primary" disabled={invalid || isSubmitting || pristine} type="submit">
                {Messages['uiComponents']['SET_SECURITY_QUESTION_BUTTON']}
              </Button>
              {isSubmitting && <CircularProgress size={24} className={classes.buttonProgress} classes={{ svgIndeterminate: classes.svg }} />}
            </DialogActions>
          </form>
        </div>
      </Dialog >
    )
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        {this.renderDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  initialValues: state.securityQuestionsFormDialog.initialValues,
  isSubmitting: state.securityQuestionsFormDialog.isSubmitting,
  answer: formValueSelector('securityQuestionsFormDialog')(state, 'answer'),
  password: formValueSelector('securityQuestionsFormDialog')(state, 'password'),
  question: formValueSelector('securityQuestionsFormDialog')(state, 'question')

})

const mapDispatchToProps = dispatch => bindActionCreators({
  preserveReduxFormValueOnToggle,
}, dispatch)

SecurityQuestionsFormDialog.propTypes = PROP_TYPES

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'securityQuestionsFormDialog',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })
)(SecurityQuestionsFormDialog)